import { useContext } from 'react';

import { websiteExtensionPoint } from '@interhyp/api-standalone-app';

import { MFError } from '../../errors/MFError.js';

import { ModuleContext } from './ModuleProvider.js';

export const WebsiteExtension = ({ props }: { props: unknown }) => {
  const { component: Component } = useWebsiteExtension();
  return <Component {...(props as any)} />;
};

const useWebsiteExtension = () => {
  const { name } = useContext(ModuleContext);
  const extension = websiteExtensionPoint.useExtension();

  if (extension === undefined) {
    throw new MFError(`No website extensions found`, name);
  }

  return extension;
};
